import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import GoalsMenu from '../components/goals/GoalsMenu.vue';
import GoalsList from '../components/goals/GoalsList.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalsView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GoalsMenu),
    (_unref(route).path === '/goals')
      ? (_openBlock(), _createBlock(GoalsList, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})